// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartTrendline": "rgba(0,0,0,.5)",
	"chartAboveMarket": "rgba(165,42,42,.5)",
	"chartBelowMarket": "rgba(61,133,106,.5)",
	"chartMarketAverage": "rgba(243,137,1,.5)"
};
export default ___CSS_LOADER_EXPORT___;
